import React from 'react';
import { Link, Route, Switch } from 'react-router-dom';
import ArtisanjobsList from './ArtisanJobsList';
import ArtisanJobsListPending from './ArtisanJobsListPennding';
import ArtisanjobsForm from './ArtisanJobsForm';
import ArtisanApplicant from './applicant/ArtisanApplicant';
import Content from '../../../../_psb/layout/Content';
import SubHeader from '../../../../_psb/layout/sub-header/SubHeader';
import Search from '../../../../components/form/Search';
import { connect } from 'react-redux';
import { setSearchValueAction } from '../../../../modules/artisanJobs/Actions';
import { searchValueSelector } from '../../../../modules/artisanJobs/Selectors';
import getLangData from '../../../../utils/getLangData';

const artisanjobs = props => {
  const { searchValue, setSearchValue } = props;
  return (
    <>
      <SubHeader
        // title={getLangData().menu.side.artisan_jobs}
        // Component={() => (
        //   <>
        //     <Switch>
        //       {/* <Route
				// 				exact
				// 				path="/artisan-jobs"
				// 				component={() => {
				// 					return (
				// 						<>
				// 							<span className="kt-subheader__separator kt-subheader__separator--v"></span>
				// 							<Search
				// 								searchValue={searchValue}
				// 								setSearchValue={setSearchValue}
				// 							/>
				// 						</>
				// 					);
				// 				}}
				// 			/> */}
        //     </Switch>
        //   </>
        // )}
      >
        <Switch>
          {/* <Route
            exact
            path='/jobs/artisan/'
            component={() => (
              <>
                <Link to='/jobs/artisan/create' className='btn btn-primary'>
                  {getLangData().buttons.add_new}
                </Link>
                <Link
                  to='/jobs/artisan/pending'
                  className='btn btn-primary ml-3'
                >
                  {getLangData().buttons.pending}
                </Link>
              </>
            )}
          /> */}
          {/* <Route
            exact
            path='/jobs/artisan/pending'
            component={() => (
              <>
                <Link
                  to='/jobs/artisan/'
                  className='btn btn-primary ml-3'
                >
                  {getLangData().fields.jobs}
                </Link>
              </>
            )}
          /> */}
          {/* <Route
            exact
            path={['/jobs/artisan/create', '/jobs/artisan/:id']}
            component={() => {
              return (
                <Link
                  to='/jobs/artisan/'
                  className='btn-label-brand btn btn-bold'
                >
                  {getLangData().buttons.back}
                </Link>
              );
            }}
          /> */}
        </Switch>
      </SubHeader>
      <Content>
        <Switch>
          <Route exact path='/jobs/artisan/' component={ArtisanjobsList} />
          <Route exact path='/jobs/artisan/pending' component={ArtisanJobsListPending} />
          <Route
            exact
            path='/jobs/artisan/create'
            component={ArtisanjobsForm}
          />
          <Route exact path='/jobs/artisan/:id' component={ArtisanjobsForm} />
          <Route exact path='/jobs/artisan/:id/applicants' component={ArtisanApplicant} />
        </Switch>
      </Content>
    </>
  );
};

const mapStateToProps = state => ({
  searchValue: searchValueSelector(state)
});

const mapDispatchToProps = {
  setSearchValue: setSearchValueAction
};

export default connect(mapStateToProps, mapDispatchToProps)(artisanjobs);
